export default {
  setForm: (state, login = -1) => {
    if (login == -1) return
    state.login.current_form = login
  },
}
